import { createReducer, standardReducer } from "./helpers";
import * as types from "actions/delegationActionTypes";

export const initialState = {
  employees: [],
  search: {
    results: {},
  },
  isfetching: false,
  isfetched: false,
  isChecking: false,
  isChecked: false,
  error: {},
};

const reducer = createReducer(initialState, {
  [types.FETCH_DELEGATION_LIST_BEGIN]: standardReducer,
  [types.FETCH_DELEGATION_LIST_SUCCESS]: standardReducer,
  [types.FETCH_DELEGATION_LIST_ERROR]: standardReducer,
  [types.FETCH_EMPLOYEE_DELEGATION_LIST_BEGIN]: standardReducer,
  [types.FETCH_EMPLOYEE_DELEGATION_LIST_SUCCESS]: standardReducer,
  [types.FETCH_EMPLOYEE_DELEGATION_LIST_ERROR]: standardReducer,
  [types.POST_CHECK_EMPLOYEE_DELEGATION_BEGIN]: standardReducer,
  [types.POST_CHECK_EMPLOYEE_DELEGATION_SUCCESS]: standardReducer,
  [types.POST_CHECK_EMPLOYEE_DELEGATION_ERROR]: standardReducer,
  [types.POST_ADD_EMPLOYEE_DELEGATION_LIST_BEGIN]: standardReducer,
  [types.POST_ADD_EMPLOYEE_DELEGATION_LIST_SUCCESS]: standardReducer,
  [types.POST_ADD_EMPLOYEE_DELEGATION_LIST_ERROR]: standardReducer,
  [types.POST_EDIT_EMPLOYEE_DELEGATION_LIST_BEGIN]: standardReducer,
  [types.POST_EDIT_EMPLOYEE_DELEGATION_LIST_SUCCESS]: standardReducer,
  [types.POST_EDIT_EMPLOYEE_DELEGATION_LIST_ERROR]: standardReducer,
  [types.POST_REVOKE_DELEGATION_BEGIN]: standardReducer,
  [types.POST_REVOKE_DELEGATION_SUCCESS]: standardReducer,
  [types.POST_REVOKE_DELEGATION_ERROR]: standardReducer,
  [types.CLEAR_SEARCH_DELEGATION_DATA]: () => initialState,
});

export default reducer;



// WEBPACK FOOTER //
// ./reducers/delegationReducer.js